import React from 'react';
import 'AppSrc/core/style/components/create-crq-screen/create-crq-success.css';
import 'AppSrc/core/style/components/app-layout/page-content.css';
import 'AppSrc/core/style/components/form/form.css';
import { useParams } from 'react-router';
import { VIEW_CRQ } from 'AppSrc/core/components/router/routes';
import { Link } from 'react-router-dom';
import {
  RAISE_CRQ,
  SUBMIT_TO_PEER_REVIEW,
  SUBMIT_TO_L3_APPROVALS,
  CANCEL_CRQ,
  SUBMIT_TO_APPROVALS,
  REJECT_FROM_PEER_REVIEW,
  APPROVED_FROM_APPROVALS,
  REJECTED_FROM_APPROVALS,
  CLOSE_CRQ,
  CLOSE_OLO_CRQ,
  CANCEL_ACTION_CRQ,
  POSTPONE_CRQ,
  // SUBMIT_TO_APPROVALS,
  OLO_SUBMIT_TO_APPROVALS,
  // REJECT_FROM_PEER_REVIEW,
  // APPROVED_FROM_APPROVALS,
  // REJECTED_FROM_APPROVALS,
  CLOSED,
} from 'AppSrc/core/crq/crq-status-transitions';
import { useSelector } from 'react-redux';
// import { useLocation } from 'react-router/cjs/react-router';

const TITLES_FOR_TRANSITION = {
  [RAISE_CRQ]: 'Your change request has been created and submitted for coordinator review.',
  [SUBMIT_TO_PEER_REVIEW]: 'Submitted for peer review',
  [SUBMIT_TO_L3_APPROVALS]: 'Submitted for L3 Approvals',
  [CANCEL_CRQ]: 'Ticket has been cancelled',
  [SUBMIT_TO_APPROVALS]: 'You have approved the CRQ',
  [REJECT_FROM_PEER_REVIEW]: 'Ticket has been rejected',
  [APPROVED_FROM_APPROVALS]: "The ticket's approval history has been updated with your signature/s",
  [REJECTED_FROM_APPROVALS]: 'Ticket has been rejected',
  [CLOSE_CRQ]: 'Unsuccessful Change Review has been submitted and the CRQ has been closed.',
  [CLOSE_OLO_CRQ]: 'CRQ has been closed as Unsuccessful and Unsuccessful Closure comms will be sent to customers.',
  [OLO_SUBMIT_TO_APPROVALS]: 'Submitted to Approvals',
  // [REJECT_FROM_PEER_REVIEW]: 'Ticket has been rejected',
  // [APPROVED_FROM_APPROVALS]: "The ticket's approval history has been updated with your signature/s",
  // [REJECTED_FROM_APPROVALS]: 'Ticket has been rejected',
  [POSTPONE_CRQ]: 'Ticket has been moved back to Coordinator review.',
  [CANCEL_ACTION_CRQ]: 'Ticket has been cancelled.',
  [CLOSED]: 'Ticket has been closed',
};

// Title for VINE CRQ ID
const TITLES_FOR_VINE_TRANSITION = {
  [RAISE_CRQ]: 'Your change request has been created and submitted for coordinator review.',
  [SUBMIT_TO_PEER_REVIEW]: 'Related Ticket',
  [CANCEL_CRQ]: 'Related Ticket has been cancelled',
  [SUBMIT_TO_APPROVALS]: 'You have Successfully created related Mobile CRQ',
  [APPROVED_FROM_APPROVALS]: 'Related Ticket',
  [REJECTED_FROM_APPROVALS]: 'Related Ticket has been rejected',
  [CLOSE_CRQ]: 'Unsuccessful Change Review has been submitted and the CRQ has been closed.',
  [POSTPONE_CRQ]: 'Related Ticket has been moved back to Coordinator review.',
  [CANCEL_ACTION_CRQ]: 'Related Ticket has been cancelled.',
  [CLOSED]: 'Related Ticket has been closed',
};
const defaultRelatedTitle = 'Related Ticket';

const defaultMessage = 'You can track its progress by clicking the link above or via the CRQ listing page';

const MESSAGE_FOR_TRANSITION = {
  [CANCEL_CRQ]: 'Please note you will not be able to reopen this ticket',
  [CLOSE_CRQ]: 'You can view CRQ details in by clicking link above or via the CRQ listing page.',
  [CLOSE_OLO_CRQ]: 'You can view CRQ details in by clicking link above or via the CRQ listing page.',
  [CANCEL_ACTION_CRQ]: 'This CRQ has been cancelled and Cancellation comms have been sent, where applicable.',
  [POSTPONE_CRQ]: 'This ticket will now appear in your CRQs for Review work queue.',
};

const CrqTransitionConfirmationScreen = () => {
  // use params is a hook that retrieves parameters from the route url
  // so in this case the path is `/crq/create/success/:network/:crqId/(:status)`
  // and useParams will retrieve the value for crqId, network and status
  const {
    crqId,
    network,
    transitionId = RAISE_CRQ,
  } = useParams();
  const relatedIdFromStore = useSelector((state) => state.remedyReferenceCrq.crqData.id);
  const viewCrqPath = VIEW_CRQ.getPath({ network, crqId });
  // const crqListPath = CRQS_SCREEN.getPath();
  const title = TITLES_FOR_TRANSITION[transitionId];
  const message = MESSAGE_FOR_TRANSITION[transitionId] || defaultMessage;

  // we have added additional crq links for related tickets if required VINE title
  // Wherever we are moving Mobile VINE CRQ by postponing or directly, we are showing same message that ticket has been
  // moved back to coordinator review.
  let titleVINE = network === 'mobile' ? defaultRelatedTitle : TITLES_FOR_VINE_TRANSITION[transitionId];
  const messageVINE = MESSAGE_FOR_TRANSITION[transitionId] || defaultMessage;

  // VINE Crq id
  const relatedCrqId = window.sessionStorage.getItem('getCurrentAdjacentRemedyRef');
  const relatedCrqId1 = window.sessionStorage.getItem('relatedCRQId');
  const vineCheckPoint = window.sessionStorage.getItem('vineCheckPoint');
  const relatedCrqStatus = window.sessionStorage.getItem('relatedStatus');
  const statusReason = window.sessionStorage.getItem('statusReason');
  let refinedRelatedCrqId = relatedCrqId1 ? relatedCrqId1 : relatedCrqId;
  // sessionStorage return string we converting to original
  refinedRelatedCrqId = refinedRelatedCrqId === 'null' || refinedRelatedCrqId === null ? null : refinedRelatedCrqId;
  refinedRelatedCrqId = (relatedIdFromStore && vineCheckPoint === 'No' && transitionId === SUBMIT_TO_APPROVALS) ? relatedIdFromStore : refinedRelatedCrqId;
  // When the rescheduled Fixed VINE CRQ reaches Circuit Check Stage again, on selecting NO for VINE impact, we cancel the Mobile CRQ.
  titleVINE = (vineCheckPoint === 'No' && transitionId === SUBMIT_TO_APPROVALS && statusReason === '10500') ? 'Related Ticket has been Cancelled' : titleVINE;
  titleVINE = (transitionId === SUBMIT_TO_APPROVALS && statusReason !== '10500') ? defaultRelatedTitle : titleVINE;
  // When Fixed VINE CRQ having impacted Mobile CRQ in scheduled stage get rejected, we simply moves the mobile ticket to coordinator stage.
  titleVINE = ((relatedCrqStatus === '6' || relatedCrqStatus === 'Scheduled') && transitionId === REJECTED_FROM_APPROVALS) ? 'Related Ticket has been moved back to Coordinator review' : titleVINE;
  // path for VINE
  const inversenetwok = network === 'fixed' ? 'mobile' : 'fixed';
  const viewCrqPathVINE = refinedRelatedCrqId !== 'null' ? `/crq/${inversenetwok}/${refinedRelatedCrqId}` : '/';

  console.log('Confirmation screen', messageVINE);

  return (
    <div className="main-form-container page-content-container crq-create-success">
      <div className="form-top page-top" />
      <div className="main-form page-content">
        <div className="form-fields page-content-inner">
          <div className="form-section">
            <h3 className="form-section-title">
              {title}
            </h3>
            <p className="success-crq-id">
              <Link to={viewCrqPath}>
                {crqId}
              </Link>
            </p>
            <p>{message}</p>
            {/* <div className="view-crqs-button">
              <Link to={crqListPath}>
                View CRQs (refinedRelatedCrqId !== null) || (vinecheck ==- no && TrID === submit approval && selectedNOID)
              </Link>
            </div> */}
          </div>
        </div>
        {
          ((refinedRelatedCrqId !== null) || (transitionId === SUBMIT_TO_APPROVALS && vineCheckPoint === 'No' && relatedIdFromStore)) && (
            <div className="form-fields page-content-inner related-crq">
              <div className="form-section">
                <h3 className="form-section-title">
                  {titleVINE}
                </h3>
                <p className="success-crq-id">
                  <Link to={viewCrqPathVINE} target="_blank">
                    {refinedRelatedCrqId}
                  </Link>
                </p>
                <p>{message}</p>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};


export { CrqTransitionConfirmationScreen };
